export default class AudioSubtitleEvent {
    constructor(type) {
        this._type = type;
    }

    get type() {
        return this._type;
    }
}


AudioSubtitleEvent.INITIALIZE = "AudioSubtitleEvent.INITIALIZE";